import styled from 'styled-components';
import tw from 'twin.macro';
import { Caption } from '../../styled components/Typography';

export const TimesheetEntryItemDelta = styled(Caption).attrs(() => ({
  $color: 'gray dark'
}))(({ $notAsPlanned, $isCancelled }) => [
  $notAsPlanned && tw`text-blue-lighten-10`,
  $isCancelled && tw`line-through`
]);

export const TimesheetEntryItemFieldAndButtonsWrapper = styled.div(
  ({ $isShiftEnd = false }) => [tw`flex`, $isShiftEnd ? tw`items-end` : tw`items-start`]
);

export default TimesheetEntryItemDelta;
